import type { RouteObject } from 'react-router-dom';
import { ReleasedFeature } from '../../release';
import { RequirePermission } from '../auth/guards';
import { BulkPage } from '../inventory/BulkPage';
import { ReportPage } from '../reports/ReportPage';
import { ConnectionsPage } from './ConnectionsPage';
import { GetStartedPage } from './GetStartedPage';
import { OtherSettingsPage } from './OtherSettingsPage';
import { ProcessingFeesPage } from './ProcessingFeesPage';
import { SettingsListByKeyPage } from './OtherSettingsPage';
import { SettingsListPage, TaxConfigPage } from './SettingsListPage';
import { ServiceAreaPage } from './ServiceAreaPage';
import { SystemConfigPage } from './SystemConfigPage';

const guard = (code: string, element: JSX.Element) => (
  <RequirePermission code={code}>{element}</RequirePermission>
);

/** System Config (PC234), Service Area (PC237) and Other Settings (PC240). */
export const configurationRoutes: RouteObject[] = [
  { path: 'settings/system', element: guard('PC234', <SystemConfigPage />) },
  { path: 'settings/service-area', element: guard('PC237', <ServiceAreaPage />) },
  // These three check the code of their list themselves.
  { path: 'settings/shipper', element: <SettingsListPage listKey="shipper-settings" /> },
  { path: 'settings/payment-gateway', element: <SettingsListPage listKey="payment-gateways" /> },
  { path: 'settings/tax-config', element: <TaxConfigPage /> },
  { path: 'settings/get-started', element: guard('PC239', <GetStartedPage />) },
  { path: 'settings/connections', element: guard('PC239', <ConnectionsPage />) },
  { path: 'integrations', element: guard('PC239', <ConnectionsPage title="Integrations" />) },
  {
    path: 'settings/customer-import',
    element: (
      <ReleasedFeature name="customer-import" page>
        <BulkPage operation="import-customers" />
      </ReleasedFeature>
    ),
  },
  // Each list inside Other Settings checks its own code as well.
  { path: 'settings/other', element: guard('PC240', <OtherSettingsPage />) },
  { path: 'settings/other/list/:key', element: guard('PC240', <SettingsListByKeyPage />) },
  {
    path: 'settings/other/bulk-notes',
    element: guard('PC240', <BulkPage operation="bulk-notes" />),
  },
  {
    path: 'settings/other/report-note-type',
    element: guard('PC240', <ReportPage reportKey="report-note-type" />),
  },
  { path: 'settings/other/processing-fees', element: guard('PC240', <ProcessingFeesPage />) },
  { path: 'settings/other/:kind', element: guard('PC240', <OtherSettingsPage />) },
];
